import { axios } from '@/libraries/axios';

export type UnlockBaseAnalyticsResponse = {
  unlockToken: string;
};

export const unlockBaseAnalytics = (password: string): Promise<UnlockBaseAnalyticsResponse> => {
  return axios.post(`/analytics/base/unlock`, { password });
};
